<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;" @click="$router.back()">工单管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">新增工单</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              label-position="right"
              class="demo-ruleForm"
            >
              <el-form-item label="工单编号" prop="orderNo">
                <el-input
                  v-model="ruleForm.orderNo"
                  size="small"
                  maxlength="80"
                  disabled
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="问题类型" prop="orderQuestionType">
                <el-select
                  v-model="ruleForm.orderQuestionType"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in workorderquestionType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="工单类型" prop="orderType">
                <el-select
                  v-model="ruleForm.orderType"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in workorderType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工单内容" prop="chatContent">
                <el-input
                  type="textarea"
                  v-model="ruleForm.chatContent"
                  size="small"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="上传附件" prop="fileName">
                <div style="display:flex;align-items: center;">
                  <el-upload
                    class="upload-demo upload-btn"
                    :action="actionUrl"
                    :on-error="handleError"
                    :on-success="handleSuccess"
                    :on-change="uploadChange"
                    multiple
                    :limit="5"
                    :show-file-list="false"
                    :auto-upload="false"
                  >
                    <el-button class="bgc-bv" size="mini">上传附件</el-button>
                  </el-upload>
                  <span style="color:#f46173"
                    >支持上传word、excel、文本、图片、pdf等，文件大小不超过3M，最多上传5个文件。</span
                  >
                </div>
                <div style="display:flex;flex-direction: column;">
                  <span
                    style="color:#409EFF"
                    v-for="(item, index) in ruleForm.NameList"
                    :key="index"
                  >
                    {{ item.name }}
                    <!-- <a @click="reomveExl" style="color: #5bb5ff;margin:0 15px">预览</a> -->
                    <a
                      @click="reomveExl(index)"
                      style="color: red;margin:0 15px"
                      >删除</a
                    >
                  </span>
                </div>
              </el-form-item>
            </el-form>
            <div class="btn-box flexcc">
              <el-button @click="doCancel" class="bgc-bv">取 消</el-button>
              <el-button class="bgc-bv" @click="doAddSave('ruleForm')"
                >确 定</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "agentAdd",
  components: {},
  data() {
    return {
      id: "",
      stu: "add",
      workorderType: [],
      workorderquestionType: [],
      workordercompanyType: [],
      ruleForm: {
        orderQuestionType: "",
        orderType: "",
        chatContent: "",
        NameList: [],
        chatFileKeys:[],
      },

      rules: {
        orderQuestionType: [
          { required: true, message: "请选择问题类型", trigger: "change" },
        ],

        orderType: [
          { required: true, message: "请选择工单类型", trigger: "change" },
        ],
        chatContent: [
          { required: true, message: "请输入工单内容", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.stu = this.$route.query.stu;
    this.getdataList();
    if (this.stu == "edit") {
      this.getInfo(this.$route.query.id);
    }
  },
  methods: {
    getdataList() {
      const workorderquestionType = this.$setDictionary(
        "WORK_ORDER_QUESTION_TYPE",
        "list"
      );
      const workordercompanyType = this.$setDictionary(
        "WORK_ORDER_COMPANY_TYPE",
        "list"
      );
      const workorderType = this.$setDictionary("WORK_ORDER_TYPE", "list");
      const list = [];
      const workordercompanyTypelist = [];
      const workorderTypelist = [];
      for (const key in workorderquestionType) {
        list.push({
          value: key,
          label: workorderquestionType[key],
        });
      }
      for (const key in workordercompanyType) {
        workordercompanyTypelist.push({
          value: key,
          label: workordercompanyType[key],
        });
      }
      for (const key in workorderType) {
        workorderTypelist.push({
          value: key,
          label: workorderType[key],
        });
      }
      this.workorderquestionType = list;
      this.workordercompanyType = workordercompanyTypelist;
      this.workorderType = workorderTypelist;
    },
    /**
     * 新增
     */
    doAddSave(formName) {
      const params = {
        orderQuestionType: this.ruleForm.orderQuestionType,
        orderType: this.ruleForm.orderType,
        chatContent: this.ruleForm.chatContent,
        chatFileKeys: this.ruleForm.chatFileKeys,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post("/repairOrder/work/order/insert/institutions/", params)
            .then((res) => {
              if (res.status == "0") {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.$router.push({
                  path: "/web/workOrder/workOrderListJg",
                  query: {
                    refresh: true,
                  },
                });
              }
            })
            .catch(() => {
              return;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getInfo(agencyId) {
      this.$post("/biz/mercantile/agency/getInfo", { agencyId })
        .then((ret) => {
          this.ruleForm = {
            ...this.ruleForm,
            ...ret.data,
          };
          this.ruleForm.agencyIdcardFront = ret.data.agencyIdcardFrontUrl;
          this.ruleForm.agencyIdcardFrontKey = ret.data.agencyIdcardFront;
          this.ruleForm.agencyIdcardBack = ret.data.agencyIdcardBackUrl;
          this.ruleForm.agencyIdcardBackKey = ret.data.agencyIdcardBack;
          this.ruleForm.businessLicense = ret.data.businessLicenseUrl;
          this.ruleForm.businessLicenseKey = ret.data.businessLicense;
          this.ruleForm.legalIdcardBack = ret.data.legalIdcardBackUrl;
          this.ruleForm.legalIdcardBackKey = ret.data.legalIdcardBack;
          this.ruleForm.legalIdcardFront = ret.data.legalIdcardFrontUrl;
          this.ruleForm.legalIdcardFrontKey = ret.data.legalIdcardFront;
          this.ruleForm.cooperationTime = [
            ret.data.agencyStartDate.replaceAll("/", "-"),
            ret.data.agencyEndDate.replaceAll("/", "-"),
          ];
          this.ruleForm.areaId = ret.data.areaIds;
          this.ruleForm.trainTypeId = ret.data.trainTypeIds;
          this.ruleForm.companyId = ret.data.companyId;
        })
        .catch((err) => {
          return;
        });
    },
    // 点击取消
    doCancel() {
      this.$router.push({
        path: "/web/workOrder/workOrderListJg",
        query: {
          refresh: true,
        },
      });
    },
    uploadChange(file) {
      let size = file.size / 1024 / 1024;
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      
      if (size > 3) {
        this.$message.error("文件大小不能超过3M");
        return;
      }

      let formData = new FormData();
      formData.append("folder ", "QUESTION");
      formData.append("file ", file.raw);
      formData.append("fileType ", extension);
      this.$Postformat("/sys/upload", formData)
        .then((result) => {
          this.ruleForm.NameList.push({
            name: file.name,
            fileKey: result.data.fileKey,
          });
            this.ruleForm.chatFileKeys.push(result.data.fileKey+'_' + file.name);
        })
        .catch(() => {
          setTimeout(() => {
            this.$message({
              type: "warning",
              message: "保存失败",
            });
          }, 300);
        });
      this.$forceUpdate();
    },
    reomveExl(index) {
      this.ruleForm.NameList.splice(index, 1);
      this.ruleForm.chatFileKeys.splice(index, 1);
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="less">
.el-textarea {
  .el-textarea__inner {
    min-height: 10rem !important;
    resize: none;
  }
}
.upload-btn {
  width: 5rem;
  height: 28px;
  .el-upload {
    width: 5rem;
    height: 28px !important;
    border: none !important;
  }
}
</style>
